__webpack_require__.p = "//static.hsappstatic.net/signup-ui-lego/static-1.20253/";